import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './UsaAboutFeatures.css';

const UsaAboutFeatures = ({ onOpenModal }) => {
  return (
    <section className="usa-about-features" id="about-features">
      <div className="usa-about-features__container">
        <div className="usa-about-features__grid">
          {/* Left Column: Features 1-3 */}
          <div className="usa-about-features__col usa-about-features__col--left">
            {/* Feature 01 */}
            <div className="usa-about-features__item usa-about-features__item--left">
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Experienced and Certified Instructors</h3>
                <p className="usa-about-features__item-desc">
                  Our tutors have proper certifications and years of teaching experience in Quranic education.
                </p>
              </div>
              <div className="usa-about-features__badge">01</div>
            </div>

            {/* Feature 02 */}
            <div className="usa-about-features__item usa-about-features__item--left">
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Adaptable Learning Timetable</h3>
                <p className="usa-about-features__item-desc">
                  You can take your classes as per your routine. We provide different timing sessions as per your requirements.
                </p>
              </div>
              <div className="usa-about-features__badge">02</div>
            </div>

            {/* Feature 03 */}
            <div className="usa-about-features__item usa-about-features__item--left">
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Personalized Teaching Approach</h3>
                <p className="usa-about-features__item-desc">
                  You'll get personalized instruction that addresses individual learning pace and strengths. The tutor focuses on areas that need additional focus and support.
                </p>
              </div>
              <div className="usa-about-features__badge">03</div>
            </div>
          </div>

          {/* Middle Column: Arched/Capsule Image */}
          <div className="usa-about-features__image-col">
            <div className="usa-about-features__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/About.avif`}
                alt="Online Quran Classes For Adults"
                className="usa-about-features__img"
              />
            </div>
          </div>

          {/* Right Column: Features 4-6 */}
          <div className="usa-about-features__col usa-about-features__col--right">
            {/* Feature 04 */}
            <div className="usa-about-features__item usa-about-features__item--right">
              <div className="usa-about-features__badge">04</div>
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Interactive Digital Platform</h3>
                <p className="usa-about-features__item-desc">
                  Our technology creates engaging lessons with screen sharing, digital materials, and clear audio for effective online learning experiences.
                </p>
              </div>
            </div>

            {/* Feature 05 */}
            <div className="usa-about-features__item usa-about-features__item--right">
              <div className="usa-about-features__badge">05</div>
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Progress Tracking System</h3>
                <p className="usa-about-features__item-desc">
                  Regular assessments and detailed reports keep you informed about your development and achievement in their Quranic studies journey.
                </p>
              </div>
            </div>

            {/* Feature 06 */}
            <div className="usa-about-features__item usa-about-features__item--right">
              <div className="usa-about-features__badge">06</div>
              <div className="usa-about-features__text">
                <h3 className="usa-about-features__item-title">Safe Learning Environment</h3>
                <p className="usa-about-features__item-desc">
                  We maintain professional standards with verified tutors and secure platforms that prioritize your kid's safety and family privacy.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Center Bottom CTA Button */}
        <div className="usa-about-features__cta">
          <button 
            onClick={onOpenModal}
            className="usa-about-features__btn"
            style={{ border: 'none', cursor: 'pointer' }}
          >
            <span>Get Free Trial For Classes</span>
            <FiArrowRight className="usa-about-features__btn-arrow" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default UsaAboutFeatures;
